import Swal from "sweetalert2";

type ConfirmOptions = {
  title: string;
  text?: string;
  confirmText?: string;
  danger?: boolean;
};

export async function confirmDialog({ title, text, confirmText = "Yes", danger = false }: ConfirmOptions) {
  const result = await Swal.fire({
    title,
    text,
    icon: danger ? "warning" : "question",
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: "Cancel",
    confirmButtonColor: danger ? "#A94E60" : "#78917C",
    cancelButtonColor: "#5A383D99",
    background: "#FFF9F7",
    color: "#5A383D",
    reverseButtons: true,
    focusCancel: true,
    heightAuto: false
  });
  return result.isConfirmed;
}
